import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useGraphQLClient } from 'modules/core/lib/graphql/provider'
import i18n from 'modules/core/lib/i18n'
import trackTransition from 'modules/core/lib/routeTransitionTracking'

interface Props {
  onClose?: () => void
}

const PaywallModal = ({ onClose = () => {} }: React.PropsWithChildren<Props>) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const graphQLClient = useGraphQLClient()

  useUnsafeEffect(() => {
    trackTransition(graphQLClient, 'paywall_modal_view')
  }, [graphQLClient])

  const onSubmit = (closePortal: ClosePortalFn) => {
    closePortal()
    navigate(navigation.upgradePlan.fullPath())
  }

  return (
    <Modal
      illustration="fireworks"
      title={i18n.t('end_of_trial.modal_copy.title')}
      description={i18n.t('end_of_trial.modal_copy.modal_description')}
      onSubmit={onSubmit}
      onClose={onClose}
      footer={
        <Button type="upgrade" submit>
          {i18n.t('end_of_trial.modal_copy.button')}
        </Button>
      }
    />
  )
}

export default observer(PaywallModal)
